<template>
  <div id="CustomerSiteMap">
    <div class="container">
      <gmap-map
        v-if="customerHomeInfo"
        class="map"
        ref="customersitemap"
        :zoom="15"
        :center="{
          lat: customerHomeInfo.latitude,
          lng: customerHomeInfo.longitude
        }"
      >
        <!-- Marker : Customer Home Location -->
        <gmap-marker
          v-if="customerHomeInfo"
          :icon="{ url: require('../../assets/customer_home.svg') }"
          :position="{
            lat: customerHomeInfo.latitude,
            lng: customerHomeInfo.longitude
          }"
        />

        <!-- Marker : Site Location -->
        <gmap-marker
          v-for="(site, index) in customerSiteList"
          :key="index"
          :title="customerSiteList.name"
          :position="{ lat: site.latitude, lng: site.longitude }"
          :icon="
            site.utilize && site.utilize > 40
              ? { url: require('../../assets/red_antenna.svg') }
              : { url: require('../../assets/green_antenna.svg') }
          "
          @click="showSiteInfoWindow(index)"
        >
          <!-- Marker : Each site infomation window -->
          <gmap-info-window
            v-if="site.isOpen"
            :opened="site.isOpen"
            @closeclick="showSiteInfoWindow(index)"
          >
            <div
              class="columns is-multiline is-gapless dtac-font"
              style="max-width: 200px;"
            >
              <div
                class="column is-12 has-text-left"
                style="padding: 0.75rem 0.25rem !important;"
              >
                <p class="title is-6" style="margin-bottom: 0.5rem;">
                  {{ site.name }}
                </p>
                <p style="font-size: 14px;">
                  {{ $t("site.utilize") }}: {{ site.utilize }}
                  <br />
                  {{ $t("site.distance") }}: {{ site.distance | todecimal(2) }}
                  <br />
                  {{ $t("site.coverage") }}: {{ site.coverage | todecimal(2) }}
                </p>
              </div>
            </div>
          </gmap-info-window>
          <!-- END - Marker : Each site infomation window -->
        </gmap-marker>
        <gmap-circle
          v-for="coverage in coverageCircles"
          :key="coverage.name"
          :visible="true"
          :radius="coverage.radius"
          :center="coverage.position"
          :options="coverage.options"
        />
      </gmap-map>
    </div>
  </div>
</template>

<script>
import AlertManager from "@/managers/AlertManager";
import CustomerApiManager from "@/apis/CustomerApiManager";

export default {
  name: "CustomerSiteMap",
  props: ["customer_id", "reload", "enable"],
  data() {
    return {
      center: { lat: 13.732447299999999, lng: 100.53140549999999 },
      coverageCircles: [],
      customerSiteList: [],
      customerHomeInfo: null
    };
  },
  watch: {
    enable: function(val) {
      if (val) {
        this.getCustomerSiteLocation();
      }
    },
    reload: function(val) {
      if (val) {
        this.reloadComponent();
        this.$emit("completed_reload");
      }
    },
    customer_id: function(val) {
      if (val) {
        this.getCustomerSiteLocation();
      }
    }
  },
  filters: {
    todecimal: function(value, decimal_place) {
      if (!value) return "";
      return Number(value).toFixed(decimal_place);
    }
  },
  methods: {
    reloadComponent: function() {
      this.coverageCircles = [];
      this.customerSiteList = [];
      this.customerHomeInfo = null;

      this.getCustomerSiteLocation();
    },
    getCustomerSiteLocation: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const customerSiteResult = await CustomerApiManager.requestCustomerSites(
        this.customer_id
      );
      loadingComponent.close();

      switch (customerSiteResult.code) {
        case "0":
          this.setupMapProperties(customerSiteResult.data);
          break;

        default:
          AlertManager.showErrorSnackbar(customerSiteResult.message);
          break;
      }
    },
    setupMapProperties: function(customerSiteInfo) {
      this.customerHomeInfo = customerSiteInfo.home;
      this.customerSiteList = customerSiteInfo.sites;
      this.drawCustomerCoverageCircleOnMap(customerSiteInfo.home);
    },
    showSiteInfoWindow: function(index) {
      let selectedSite = this.customerSiteList[index];
      const displayedSites = this.coverageCircles.find(
        coverageInfo => coverageInfo.name === selectedSite.name
      );
      if (displayedSites) {
        selectedSite.isOpen = false;
        const filtered = this.coverageCircles.filter(function(circleInfo) {
          return circleInfo.name != displayedSites.name;
        });
        this.coverageCircles = filtered;
      } else {
        selectedSite.isOpen = true;
        this.drawSiteCoverageCircleOnMap(selectedSite);
      }
    },
    drawSiteCoverageCircleOnMap: function(siteInfo) {
      let circle = {
        name: siteInfo.name,
        position: { lat: siteInfo.latitude, lng: siteInfo.longitude },
        options: {
          fillOpacity: 0.3,
          strokeWeight: 0
        }
      };
      // Condition : If site not provided a coverage value alert an error, otherwise do a normal process
      if (!siteInfo.coverage) {
        circle.radius = 0;
        AlertManager.showErrorSnackbar(
          siteInfo.name + " site's coverage not found"
        );
      } else {
        if (siteInfo.utilize > 40) {
          // Red Area: Cannot Sale with utilize >= 40%
          circle.options.fillColor = "#E74C3C";
          circle.radius = Math.abs(siteInfo.coverage);
        } else if (siteInfo.utilize >= 0 && siteInfo.utilize <= 40) {
          // Green Area: Can Sale with utilize < 40%
          circle.options.fillColor = "#80D840";
          circle.radius = Math.abs(siteInfo.coverage);
        } else {
          // Orange Area: Unknown with no utilize
          circle.options.fillColor = "#FFA500";
          circle.radius = 800;
        }
      }
      this.coverageCircles.push(circle);
    },
    drawCustomerCoverageCircleOnMap: function(homeInfo) {
      let circle = {
        name: "HOME",
        radius: homeInfo.lock_distance,
        position: { lat: homeInfo.latitude, lng: homeInfo.longitude },
        options: {
          fillColor: "#00AEEF",
          fillOpacity: 0.2,
          strokeColor: "#00AEEF",
          strokeWeight: 1
        }
      };
      this.coverageCircles.push(circle);
    }
  },
  mounted() {
    if (this.enable) this.getCustomerSiteLocation();
  }
};
</script>

<style scoped>
.map {
  width: 100%;
  height: 80vh;
}
</style>
